export default {
  app: {
    title: 'Визуальная платформа',
    myCanvases: 'Мои холсты',
    modules: 'Модули',
    settings: 'Настройки',
    profile: 'Профиль',
    beta: 'Бета',
    logs: 'Журнал',
    menu: 'Меню',
    back: 'Назад',
    updateAvailable: 'Доступна новая версия платформы — обновите страницу, когда будет удобно. Данные сохранены.',
  },
  home: {
    cover: 'Обложка',
    coverPreview: 'Превью холста',
    newCanvas: 'Новый холст',
    add: 'Добавить',
    addNotebook: 'Блокнот',
    addSpace: 'Пространство',
    inDevelopment: 'В разработке',
    import: 'Импорт',
    exportAll: 'Экспорт всех холстов',
    empty: 'Пока нет ни одного холста. Создайте первый.',
    untitled: 'Без названия',
    objects: '{n} объект|{n} объекта|{n} объектов',
    updated: 'Изменён {date}',
    open: 'Открыть',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    export: 'Экспорт',
    delete: 'Удалить',
    confirmDelete: 'Удалить холст «{name}»? Это действие нельзя отменить.',
    lastExport: 'Последний экспорт: {days} дн. назад',
    lastExportNever: 'Резервная копия ещё не создавалась',
    backupHint: 'Данные хранятся только в этом браузере. Регулярно делайте экспорт для резервной копии.',
    storage: 'Хранилище: {used} из {quota}',
    storageWarn: 'Хранилище почти заполнено: {pct}%',
    persistDenied: 'Браузер не разрешил постоянное хранилище — данные могут быть удалены при нехватке места.',
    search: 'Поиск холстов',
    pin: 'Закрепить',
    unpin: 'Открепить',
    pinned: 'Закреплён',
    pick: 'Выбрать',
    pickAll: 'Все',
    pickNone: 'Снять',
    pickDone: 'Готово',
    picked: '{n} выбран|{n} выбрано|{n} выбрано',
    bulk: 'Действия с выбранными холстами',
    confirmDeleteMany: 'Удалить {n} холст? Это действие нельзя отменить.|Удалить {n} холста? Это действие нельзя отменить.|Удалить {n} холстов? Это действие нельзя отменить.',
    layout: 'Вид холстов',
    layoutGrid: 'Плитка',
    layoutList: 'Список',
    today: 'сегодня, {time}',
    backupAction: 'сделать резервную копию',
    persistShort: 'Хранилище не постоянное',
  },
  canvas: {
    importAs: 'Импорт: {name}',
    exportAs: 'Экспорт: {name}',
    saved: 'Сохранено',
    saving: 'Сохранение…',
    saveError: 'Ошибка сохранения',
    loading: 'Загрузка… {n}',
    readOnly: 'Только чтение: холст открыт в другой вкладке',
    takeOver: 'Забрать управление',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    export: 'Экспорт архива',
    exportPng: 'Экспорт PNG',
    exportSvg: 'Экспорт SVG',
    exportPdf: 'Экспорт PDF',
    importSvg: 'Импорт SVG…',
    close: 'Закрыть',
    namePrompt: 'Название холста',
    quarantined: 'Повреждённых записей перемещено в карантин: {n}',
    recovered: 'Восстановлено несохранённых изменений: {n}',
  },
  tools: {
    templates: 'Шаблоны',
    title: 'Инструменты',
    pen: 'Карандаш (B)',
    path: 'Перо (P)',
    pathHint: 'Клик — угол, протянуть — кривая (Alt — излом). Клик по первой точке замыкает, по концу готового контура — продолжает. Enter или двойной клик — завершить, Backspace — убрать точку',
    pathEditHint: 'Тяните точки и усы (Alt — сломать усы). Клик по контуру — новая точка, Alt-клик по точке — угол или гладкая, Delete — удалить точку, Esc — готово',
    draw: 'Рисование',
    eraser: 'Ластик (E)',
    more: 'Ещё',
    penColor: 'Цвет линии',
    penWidth: 'Толщина',
    penHue: 'Тон',
    penSat: 'Насыщенность',
    penLight: 'Яркость',
    penSharp: 'Чёткий штрих',
    penSmooth: 'Автосглаживание',
    penCustom: 'Свой цвет',
    brushTitle: 'Материал',
    strokeTitle: 'Штрих',
    brush: {
      ink: 'Ручка',
      highlighter: 'Выделитель',
    },
    select: 'Выбор (V)',
    hand: 'Рука (H)',
    lasso: 'Лассо (Q)',
    shapes: 'Фигуры',
    rect: 'Прямоугольник (R)',
    pill: 'Капсула',
    node: 'Узел',
    manualInput: 'Ручной ввод',
    data: 'Данные',
    document: 'Документ',
    display: 'Дисплей',
    bracket: 'Скобка с комментарием',
    brace: 'Фигурная скобка, заметка справа',
    braceLeft: 'Фигурная скобка, заметка слева',
    ellipse: 'Эллипс (O)',
    triangle: 'Треугольник',
    diamond: 'Ромб',
    text: 'Текст (T)',
    sticker: 'Стикер (S)',
    frame: 'Рамка (F)',
    image: 'Изображение',
    lines: 'Линии',
    line: 'Линия (L)',
    arrow: 'Стрелка',
    connector: 'Соединитель (C)',
    moduleTools: 'Модули',
  },
  cmd: {
    unframe: 'Убрать рамку, оставить содержимое',
    undo: 'Отменить (Ctrl+Z)',
    redo: 'Повторить (Ctrl+Shift+Z)',
    delete: 'Удалить',
    duplicate: 'Дублировать (Ctrl+D)',
    copy: 'Копировать (Ctrl+C)',
    cut: 'Вырезать (Ctrl+X)',
    paste: 'Вставить (Ctrl+V)',
    copyPng: 'Копировать как PNG',
    group: 'Сгруппировать (Ctrl+G)',
    ungroup: 'Разгруппировать (Ctrl+Shift+G)',
    lock: 'Заблокировать (Ctrl+L)',
    unlock: 'Разблокировать (Ctrl+L)',
    order: 'Порядок',
    front: 'На передний план',
    forward: 'Вперёд',
    backward: 'Назад',
    back: 'На задний план',
    align: 'Выравнивание',
    alignLeft: 'По левому краю',
    alignCenterX: 'По центру (гориз.)',
    alignRight: 'По правому краю',
    alignTop: 'По верхнему краю',
    alignCenterY: 'По центру (верт.)',
    alignBottom: 'По нижнему краю',
    distributeX: 'Распределить по горизонтали',
    distributeY: 'Распределить по вертикали',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    zoomReset: 'Масштаб 100%',
    fitAll: 'Вместить всё (Shift+1)',
    selectAll: 'Выделить всё',
    editText: 'Редактировать текст',
    showData: 'Исходные данные',
    exportSelection: 'Экспорт выделения',
    exportFrame: 'Экспорт рамки',
  },
  props: {
    style: 'Стиль',
    dockSide: 'Свойства в боковую панель',
    dockTop: 'Вернуть свойства наверх',
    font: 'Шрифт',
    title: 'Свойства',
    frameUntitled: 'Рамка',
    clipContent: 'Обрезать содержимое',
    nothing: 'Ничего не выбрано',
    multiple: 'Выбрано объектов: {n}',
    canvas: 'Холст',
    stroke: 'Обводка',
    strokeColor: 'Цвет обводки',
    strokeWidth: 'Толщина',
    dash: 'Тип линии',
    solid: 'Сплошная',
    dashed: 'Пунктир',
    fine: 'Мелкий пунктир',
    dotted: 'Точки',
    none: 'Нет',
    fill: 'Заливка',
    fillKind: 'Тип заливки',
    fillSolid: 'Сплошная',
    fillLines: 'Линии',
    fillGrid: 'Сетка',
    fillNone: 'Нет',
    fillColor: 'Цвет заливки',
    patternBg: 'Фон узора',
    fillType: 'Тип',
    color: 'Цвет',
    patternColor: 'Цвет линий',
    patternGap: 'Между линиями',
    transparent: 'Прозрачно',
    density: 'Частота',
    densitySparse: 'Редко',
    densityMedium: 'Средне',
    densityDense: 'Часто',
    mixed: 'Разные значения',
    contour: 'Контур',
    line: 'Линия',
    lineStyle: 'Стиль',
    noContour: 'Без контура',
    arrowNone: 'Без стрелок',
    arrowBoth: 'С двух сторон',
    size: 'Размер',
    hAlign: 'По горизонтали',
    vAlign: 'По вертикали',
    top: 'Сверху',
    middle: 'По центру',
    bottom: 'Снизу',
    fontStyle: 'Начертание',
    object: 'Объект',
    editPoints: 'Точки',
    editPointsHint: 'Править точки контура (двойной клик или Enter)',
    arrange: 'Порядок и группы',
    applyHint: 'Применится к {n} из {total}',
    opacity: 'Прозрачность',
    text: 'Текст',
    fontSize: 'Размер шрифта',
    textColor: 'Цвет текста',
    align: 'Выравнивание',
    bold: 'Жирный',
    italic: 'Курсив',
    position: 'Положение и размер',
    rotation: 'Поворот',
    cornerRadius: 'Скругление',
    arrows: 'Стрелки',
    arrowStart: 'В начале',
    arrowEnd: 'В конце',
    route: 'Маршрут',
    routeOrthogonal: 'Ортогональный',
    routeStraight: 'Прямой',
    routeCurved: 'Плавный',
    labelAdd: 'Надпись',
    labelEdit: 'Изменить надпись',
    labelHint: 'Надпись на стрелке (или двойной клик по ней)',
    locked: 'Заблокирован',
    type: 'Тип',
    module: 'Модуль',
    name: 'Название',
    moduleProps: 'Свойства модуля',
    stale: 'Данные устарели — модуль не ответил вовремя',
    links: 'Связи',
    addLink: 'Связать с…',
    linkHint: 'Выберите два объекта, чтобы создать связь данных',
    createLink: 'Создать связь',
    removeLink: 'Удалить связь',
    unavailable: 'Этот объект не удалось отобразить. Функционал для его отображения недоступен.',
  },
  grid: {
    title: 'Сетка',
    show: 'Показывать сетку',
    kind: 'Вид',
    dots: 'Точки',
    lines: 'Линии',
    cells: 'Ячейки',
    step: 'Шаг',
    color: 'Цвет',
    snap: 'Привязка к сетке',
  },
  tree: {
    title: 'Объекты',
    empty: 'Холст пуст',
    group: 'Группа',
    search: 'Найти объект',
    nothingFound: 'Ничего не найдено',
  },
  types: {
    'core:rect': 'Прямоугольник',
    'core:ellipse': 'Эллипс',
    'core:triangle': 'Треугольник',
    'core:diamond': 'Ромб',
    'core:text': 'Текст',
    'core:sticker': 'Стикер',
    'core:frame': 'Рамка',
    'core:image': 'Изображение',
    'core:line': 'Линия',
    'core:connector': 'Соединитель',
    'core:group': 'Группа',
    'core:path': 'Контур',
    'core:diagram': 'Схема',
    'core:pen': 'Рисунок',
  },
  search: {
    filters: 'Фильтры',
    byType: 'Тип',
    byColor: 'Цвет',
    resetFilters: 'Сбросить фильтры',
    title: 'Поиск по холсту',
    placeholder: 'Найти на холсте',
    none: 'не найдено',
    prev: 'Предыдущий (Shift+Enter)',
    next: 'Следующий (Enter)',
  },
  keys: {
    palette: 'Палитра команд',
    style: 'Копировать / вставить стиль',
    notes: 'Комментарии объекта',
    modules: 'Модули',
    saved: 'Сохранено',
    save: 'Сохранить сейчас',
    next: 'Следующий / предыдущий объект',
    shapeOps: 'Сложение / вычитание / пересечение / исключение фигур',
    title: 'Горячие клавиши',
    tools: 'Инструменты',
    edit: 'Редактирование',
    view: 'Вид и навигация',
    mouse: 'Мышь',
    clipboard: 'Копировать / вырезать / вставить',
    group: 'Сгруппировать / разгруппировать',
    lock: 'Заблокировать / разблокировать',
    order: 'Вперёд / назад',
    orderEdge: 'На передний / задний план',
    nudge: 'Сдвинуть на 1 (10) единиц',
    escape: 'Отмена действия / снять выделение',
    zoom: 'Приблизить / отдалить',
    fitSelection: 'Показать выделенное',
    viewBack: 'Предыдущий вид (Alt+←)',
    viewForward: 'Следующий вид (Alt+→)',
    zen: 'Дзен: скрыть панели. Esc возвращает их',
    addSelect: 'Добавить к выделению',
    keepRatio: 'Сохранить пропорции / ось при перемещении',
    noSnap: 'Без направляющих при перемещении',
    ctrlDrag: 'Ctrl (⌘) + перетаскивание',
    dragCopy: 'Дублировать и перенести копию',
    dblclick: 'Редактировать текст / действие на пустом месте',
    shiftClick: 'Shift + клик',
    doubleClick: 'Двойной клик',
  },
  zen: {
    enter: 'Дзен',
    exit: 'Выйти из Дзена',
    on: 'Дзен. Панели скрыты',
  },
  minimap: {
    title: 'Мини-карта',
    hint: 'Нажмите или тяните, чтобы перейти; колесо — масштаб',
  },
  perf: {
    title: 'Производительность',
    fps: 'FPS',
    frame: 'Кадр, мс',
    backend: 'Графика',
    objects: 'Объектов',
    visible: 'Видимых',
    drawCalls: 'Вызовов отрисовки',
    textures: 'Текстур',
    memory: 'Память JS',
    workers: 'Модули (Workers)',
    api: 'API модулей, мс',
    index: 'Индекс',
    autosave: 'Автосохранение, мс',
    load: 'Загрузка холста, мс',
    unavailable: 'недоступно',
    generate: 'Сгенерировать',
    switchBackend: 'Переключить',
  },
  settings: {
    onAccent: 'Текст и иконки на кнопках',
    onAccentHint: 'На кнопках цвета акцента',
    accentInk: 'Акцентный текст и иконки',
    accentInkHint: 'Выбранные пункты, активные кнопки и значки',
    inkAuto: 'Авто',
    inkAutoNow: 'подбирается для читаемости',
    inkLowContrast: 'Выбранный цвет плохо читается (контраст {ratio}:1, нужно от 4.5:1).',
    secAppearance: 'Оформление',
    secStorage: 'Хранилище',
    secAbout: 'О программе',
    theme: 'Тема',
    themeHint: 'Светлая, тёмная или как в системе',
    homeLayout: 'Мои холсты',
    homeLayoutHint: 'Плитка или список на главном экране',
    glass: 'Прозрачность',
    glassHint: 'Меню и панель холста. Выше — сильнее просвечивает то, что под ними',
    noMotion: 'Отключить анимации',
    noMotionHint: 'Прозрачность панелей, наклон карточки имени и остальные эффекты',
    theme_system: 'Как в системе',
    theme_light: 'Светлая',
    theme_dark: 'Тёмная',
    accent: 'Акцентный цвет',
    accentHint: 'Цвет кнопок, выделения и активных элементов',
    accentPreview: 'Так выглядят кнопки',
    accentSample: 'Выбрано',
    darkCanvas: 'Тёмный холст в тёмной теме',
    darkCanvasHint: 'Белое становится тёмным, чёрный текст — светлым, оттенки сохраняются. Картинки и экспорт — в исходных цветах',
    title: 'Настройки',
    language: 'Язык',
    renderer: 'Отрисовка',
    renderer2d: 'Canvas 2D',
    marquee: 'Рамка выделения захватывает',
    marqueeIntersect: 'Задетые рамкой',
    marqueeContain: 'Целиком внутри',
    emptyDrag: 'Перетаскивание по пустому месту',
    emptyDragMarquee: 'Выделяет',
    emptyDragPan: 'Двигает холст',
    emptyDbl: 'Двойной щелчок по пустому месту',
    emptyDblText: 'Создаёт текст',
    emptyDblZoom: 'Приближает',
    emptyDblNone: 'Ничего',
    rightDrag: 'Двигать холст правой кнопкой',
    rightDragHint: 'Зажмите правую кнопку мыши и ведите — холст движется. Короткий щелчок по-прежнему открывает меню.',
    devMode: 'Режим разработчика',
    devModeHint: 'Разрешает установку сторонних модулей из файлов.',
    devModeWarn:
      'Сторонние модули выполняют чужой код. Изоляция в этой версии защищает от ошибок, но не от злонамеренного кода. Устанавливайте только модули из источников, которым доверяете.',
    verbose: 'Подробная отладка',
    verboseHint: 'Записывает полные данные объектов в журнал. Отключится автоматически через 15 минут или при закрытии редактора.',
    perfPanel: 'Панель производительности',
    backgroundColor: 'Цвет фона холста',
    textLod: 'Упрощать мелкий текст',
    secGeneral: 'Общие',
    secCanvas: 'Холст',
    secControl: 'Управление',
    secPerformance: 'Производительность',
    secDeveloper: 'Для разработчиков',
    languageHint: 'Язык интерфейса и подписей модулей.',
    backgroundHint: 'Цвет под всеми объектами.',
    grid: 'Сетка',
    gridStep: 'Шаг сетки',
    snap: 'Привязка к сетке',
    snapHint: 'Объекты встают по узлам сетки при перемещении и изменении размера.',
    smartGuides: 'Умные направляющие',
    smartGuidesHint: 'Подсказывают выравнивание по краям и центрам соседних объектов.',
    minimap: 'Миникарта',
    minimapHint: 'Карта холста в правом нижнем углу для быстрой навигации.',
    emptyDragHint: 'Что происходит, если тянуть мышью по пустому месту.',
    emptyDblHint: 'Пустое место и внутренняя область рамки: создать текст, приблизить вдвое или ничего не делать.',
    marqueeHint: 'Какие объекты попадают в рамку выделения.',
    rendererHint: 'WebGL 2 быстрее на больших холстах; Canvas 2D — для совместимости.',
    webgl: 'WebGL 2',
    textLodHint: 'Текст мельче этого размера на экране рисуется полосой — так быстрее при отдалении.',
    perfPanelHint: 'FPS, число объектов, память и время операций.',
    verboseLeft: 'ещё {n} мин',
    off: 'выкл.',
  },
  sidebar: {
    panelSec: 'Панель модуля',
    showButton: 'Кнопка в правой панели',
    showButtonHint: 'Кнопка модуля рядом с поиском открывает его панель справа',
    hideButton: 'Убрать кнопку из правой панели',
    rightClickHide: 'правый щелчок убирает кнопку',
    buttonHidden: 'Кнопка убрана. Вернуть: Настройки → Модули → страница модуля',
    buttonShown: 'Кнопка возвращена в правую панель',
    panelsMenu: 'Панели модулей',
    panelsLimit: 'В правой панели — до {n} кнопок, в этом порядке. Остальные открываются отсюда.',
    overLimit: 'не помещается',
    moveUp: 'Выше',
    moveDown: 'Ниже',
  },
  chat: {
    open: 'Чат',
    close: 'Закрыть чат',
    channels: 'Раздел чата',
    ai: 'AI',
    team: 'Команда',
    personal: 'Личный',
    placeholder: 'Сообщение…',
    send: 'Отправить',
    emptyAi: 'Спросите про этот холст. Переписка остаётся у него.',
    emptyTeam: 'Сообщения команды по этому холсту.',
    emptyPersonal: 'Заметки к этому холсту — только на этом устройстве.',
    you: 'Вы',
    reply: 'Ответить',
    deleteMsg: 'Удалить',
    replying: 'Ответ',
    replyGone: 'Сообщение удалено',
  },
  feed: {
    open: 'Лента',
    close: 'Закрыть ленту',
    sections: 'Раздел ленты',
    chat: 'Чат',
    notices: 'Уведомления',
    templates: 'Шаблоны',
    tools: 'Инструменты',
    toolsPlatform: 'Платформа',
    toolsModules: 'Модули',
    toolsOpenCanvas: 'Инструменты модулей работают с холстом — откройте холст.',
    tool: {
      palette: 'Палитра команд',
      paletteHint: 'Любое действие по названию (Ctrl+K)',
      findHint: 'Текст на доске (Ctrl+F)',
      diagramHint: 'Схема из текста',
    },
    noticesEmpty: 'Уведомлений пока нет.',
    templatesEmpty: 'Шаблонов пока нет.',
    syncHint: 'Когда появится облако, раздел сможет обновляться с других устройств.',
    emptyAi: 'Можно написать без холста. ! и название — выбрать холст из списка.',
    emptyPersonal: 'Личные заметки только на этом устройстве. ! привяжет запись к холсту.',
    linked: 'Холст',
    canvasGone: 'Холст удалён',
    pickCanvas: 'Холсты',
  },
  profiles: {
    placeTitle: 'Где хранить холсты',
    warnTitle: 'Внимание',
    warnBrowser: 'При очистке данных браузера данные профиля также будут удалены.',
    warnFolder: 'Данные хранятся на устройстве в открытом виде. Данные можно похитить, подменить или удалить. Это особенность приложения.',
    placeFixed: 'Место хранения выбирается один раз и потом не меняется.',
    placeNoFolder: 'Хранить в папке можно в Chrome, Edge, Opera и Яндекс Браузере на компьютере. Место хранения потом не меняется.',
    folderPick: 'Выбрать папку…',
    folderOther: 'Другая папка…',
    folderIsShared: 'Это общая папка профилей: у этого профиля в ней будет своя подпапка.',
    folderFailed: 'Папку не получилось выбрать: {msg}',
    title: 'Профили',
    firstTitle: 'Создайте профиль',
    firstLead: 'В профиле хранятся ваши холсты, модули и настройки. Он остаётся на этом устройстве.',
    newTitle: 'Новый профиль',
    chooseTitle: 'Кто здесь?',
    defaultName: 'Мой профиль',
    create: 'Создать профиль',
    createFailed: 'Профиль не создан: {msg}',
    new: 'Новый профиль',
    import: 'Импортировать профиль из файла',
    importFailed: 'Профиль не импортирован: {msg}',
    imported: 'Профиль «{name}» добавлен на устройство',
    export: 'Экспорт профиля',
    exportFailed: 'Профиль не экспортирован: {msg}',
    exportFirst: 'Сначала экспортировать профиль',
    switch: 'Сменить профиль',
    actions: 'Действия профиля',
    other: 'Выбрать другой профиль',
    onDevice: 'Профили на этом устройстве',
    onDeviceHint: 'У каждого профиля свои холсты, модули, настройки и чаты',
    limit: 'На устройстве может быть не больше {n} профилей',
    locked: 'Защищён PIN-кодом',
    lockedTitle: 'Профиль заблокирован',
    lockNow: 'Заблокировать',
    unlock: 'Войти',
    protect: 'Защитить PIN-кодом',
    pin: 'PIN-код',
    pinPlaceholder: 'PIN-код',
    pinNew: 'Новый PIN (4–8 цифр)',
    pinRepeat: 'Повторите PIN',
    pinCurrent: 'Текущий PIN',
    pinCurrentWrong: 'Текущий PIN неверный',
    pinMismatch: 'PIN-коды не совпадают',
    pinNote: 'PIN закрывает профиль от случайного просмотра, но не шифрует данные: они лежат открыто в браузере или в папке. Сбросить забытый PIN нельзя — только удалить профиль.',
    pinWrong: 'Неверный PIN. Осталось попыток до паузы: {n}',
    pinWait: 'Слишком много неверных попыток. Следующая — через {time}',
    pinOn: 'PIN-код задан',
    pinOff: 'PIN-код не задан',
    pinSaved: 'PIN-код сохранён',
    pinRemoved: 'PIN-код снят',
    autoLock: 'Блокировать после простоя',
    autoLockOff: 'Нет',
    minutes: '{n} мин',
    forgot: 'Забыли PIN? Удалить профиль',
    forgotPin: 'Забыли PIN-код',
    delete: 'Удалить профиль',
    deleteTitle: 'Удалить профиль «{name}»?',
    deleteWhat: 'Удалятся {n} холст, модули, настройки и чаты этого профиля. Отменить нельзя.|Удалятся {n} холста, модули, настройки и чаты этого профиля. Отменить нельзя.|Удалятся {n} холстов, модули, настройки и чаты этого профиля. Отменить нельзя.',
    deleteWhatUnknown: 'Удалятся все холсты, модули, настройки и чаты этого профиля. Отменить нельзя.',
    deleteFolder: 'Файлы холстов в папке «{folder}» тоже будут удалены.',
    deleteType: 'Чтобы подтвердить, введите имя профиля: {name}',
    deleteForever: 'Удалить навсегда',
    deleted: 'Профиль удалён',
    deletedFolderLeft: 'Профиль удалён, но к папке с его холстами не было доступа — файлы в ней остались.',
    pictureRemove: 'Убрать',
    pictureTooBig: 'Картинка больше 5 МБ',
    pictureBad: 'Это не картинка (подходят PNG, JPEG, WebP, GIF)',
    folderKindTitle: 'Как использовать папку?',
    folderKind: 'Папка пустая. В ней могут лежать холсты только этого профиля, или она может быть общей для нескольких профилей этого устройства — у каждого своя подпапка.',
    folderOwn: 'Только этот профиль',
    folderShared: 'Общая для профилей',
    folderOwned: 'Эта папка принадлежит другому профилю. Выберите другую или общую папку профилей.',
  },
  look: {
    title: 'Оформление: {name}',
    tray: 'подложка',
    trayButton: 'Оформление подложки',
    looks: 'Оформление',
    edit: 'Оформление карточки',
    reset: 'Сбросить',
    done: 'Готово',
    background: 'Фон',
    bg: { none: 'Нет', color: 'Цвет', gradient: 'Градиент', image: 'Картинка' },
    color: 'Цвет',
    colors: 'Цвета',
    gradient: { linear: 'Линейный', radial: 'Круговой' },
    angle: 'Угол',
    fit: 'Размещение',
    'fit.cover': 'Заполнить',
    'fit.contain': 'Вписать',
    'fit.tile': 'Плиткой',
    otherImage: 'Другая картинка',
    motion: 'Движение',
    motions: { none: 'Нет', gradient: 'Градиент', particles: 'Частицы', waves: 'Волны', shine: 'Сияние' },
    opacity: 'Прозрачность',
    blur: 'Размытие',
    radius: 'Скругление',
    border: 'Рамка',
    borderWidth: 'Толщина рамки',
    kind: 'Вид',
    frame: 'Рамка и тень',
    shadow: 'Тень',
    shadows: { none: 'Нет', soft: 'Мягкая', strong: 'Сильная' },
  },
  cardEditor: {
    title: 'Редактор карточек',
    back: 'Профиль',
    titlePlaceholder: 'Название карточки',
    untitled: 'Без названия',
    undo: 'Отменить',
    redo: 'Повторить',
    grid: 'Сетка 8 px',
    preview: 'Просмотр',
    add: 'Добавить в профиль',
    save: 'Сохранить',
    added: 'Карточка добавлена в профиль',
    updated: 'Карточка сохранена',
    remove: 'Удалить карточку',
    removeAsk: 'Удалить карточку? Её состояние тоже удалится.',
    leaveAsk: 'Есть несохранённые изменения. Выйти без сохранения?',
    leave: 'Выйти',
    limit: 'Карточек не больше 20 — удалите ненужную',
    tooBig: 'Картинка больше 500 КБ',
    pasteHint: 'Скопируйте картинку и нажмите Ctrl+V — до 500 КБ',
    elements: 'Элементы',
    templates: 'Шаблоны',
    mine: 'Мои карточки',
    new: 'Новая карточка',
    card: 'Карточка',
    deleteEl: 'Удалить элемент',
    keysHint: 'Стрелки — сдвиг (Shift — на 8), Delete — удалить, Ctrl+V — картинка',
    previewHint: 'Карточка работает как в профиле; состояние просмотра не сохраняется',
    el: { rect: 'Прямоугольник', circle: 'Круг', line: 'Линия', text: 'Текст', icon: 'Значок', image: 'Картинка', button: 'Кнопка', toggle: 'Переключатель', checkbox: 'Флажок', counter: 'Счётчик', note: 'Заметка', time: 'Время', date: 'Дата', weekday: 'День недели', countdown: 'Отсчёт', profile: 'Счётчик профиля' },
    p: { text: 'Текст', colors: 'Цвета', color: 'Цвет', fill: 'Заливка', size: 'Размер', bold: 'Жирный', align: 'Выравнивание', link: 'Ссылка', range: 'Мин · макс · шаг', min: 'Минимум', max: 'Максимум', step: 'Шаг', date: 'Дата', stat: 'Показатель', radius: 'Скругление', opacity: 'Непрозрачность', rotate: 'Поворот', effect: 'Эффект', trigger: 'Когда', cardSize: 'Размер' },
    align: { left: 'Слева', center: 'По центру', right: 'Справа' },
    stat: { canvases: 'Холсты', objects: 'Объекты', opens: 'Открытия', days: 'Дни' },
    fx: { none: 'Нет', appear: 'Появление', pulse: 'Пульс', sway: 'Покачивание', spin: 'Вращение', shimmer: 'Мерцание' },
    tr: { always: 'Всегда', hover: 'Наведение', press: 'Нажатие', change: 'Изменение' },
    tpl: { habits: 'Привычки', habit1: 'Зарядка', habit2: 'Прогулка', habit3: 'Книга 20 минут', water: 'Вода', waterText: 'Стаканов воды сегодня', countdown: 'Отсчёт', countdownText: 'До Нового года', note: 'Заметка', notePlaceholder: 'Напишите что-нибудь…' },
  },
  profile: {
    title: 'Профиль',
    canvases: 'Холсты',
    objects: 'Объекты',
    popular: 'Самый популярный холст',
    clock: 'Часы',
    popularEmpty: 'Пока нет холстов',
    firstName: 'Имя',
    lastName: 'Фамилия',
    avatar: 'Фото аватара',
    avatarChoose: 'Выбрать фото',
    editStats: 'Редактировать',
    library: 'Библиотека панелей',
    panels: 'Панели',
    editCard: 'Изменить карточку',
    libraryEmpty: 'Все панели уже на профиле',
    addPanel: 'Добавить',
    stickers: 'Стикеры',
    stickersHint: 'Нажмите, чтобы приклеить на карточку',
    stickersFull: 'Больше стикеров не поместится',
    removeSticker: 'Отклеить стикер',
    cardMakers: 'Создать карточку',
    openMaker: 'Открыть',
    cardLinkAsk: 'Карточка модуля открывает адрес {url}. Открыть?',
    cardLinkOpen: 'Открыть',
    removePanel: 'Убрать панель',
    deleteData: 'Удалить данные',
    exportData: 'Экспортировать',
    security: 'Безопасность',
    pinSet: 'Задать пин-код',
    pinChange: 'Изменить пин-код',
    pinDelete: 'Удалить пин-код',
    passkey: 'Добавить Passkey',
    unset: 'Не указано',
  },
  chatSettings: {
    title: 'Настройки чата',
    hint: 'Сообщения чатов хранятся в этом браузере',
    open: 'Управлять',
    empty: 'Сохранённых сообщений нет.',
    feed: 'Лента (без холста)',
    count: '{n} сообщение|{n} сообщения|{n} сообщений',
    deleteFor: 'Удалить сообщения: {name}',
    deleteAll: 'Удалить все сообщения',
    confirmFor: 'Удалить все сообщения чата «{name}»? Это действие нельзя отменить.',
    confirmAll: 'Удалить все сохранённые сообщения во всех чатах? Это действие нельзя отменить.',
  },
  modules: {
    dependency: 'Модулю нужен другой модуль: {what}. Установите его сначала.',
    dependentsBlock: 'Этот модуль нужен другим: {what}. Сначала удалите их.',
    requires: 'Требует',
    templateFailed: 'Шаблон не вставился: {msg}',
    importFailed: 'Импорт не удался: {msg}',
    exportFailed: 'Экспорт не удался: {msg}',
    title: 'Модули',
    confirmAccess: 'Подтвердить доступ',
    installUpdate: 'Обновить из файла',
    devOnly: 'Установка сторонних модулей доступна только в режиме разработчика.',
    enableDev: 'Включить режим разработчика',
    none: 'Модули не установлены',
    enabled: 'Включён',
    disabled: 'Отключён',
    isolated: 'Изолирован',
    crashed: 'Сбой',
    running: 'Работает',
    incompatible: 'Несовместим',
    version: 'Версия {v}',
    author: 'Автор: {a}',
    api: 'API: {r}',
    permissions: 'Разрешения',
    perm: {
      'canvas.read': 'Чтение холста',
      'canvas.write': 'Изменение холста',
      files: 'Работа с файлами',
      clipboard: 'Буфер обмена',
      mcp: 'Вызов других модулей (ИИ)',
      feed: 'Инструменты в ленте',
      'canvas.create': 'Создание холстов',
      keyboard: 'Клавиатура',
      fullscreen: 'Полный экран',
      'pointer-lock': 'Захват указателя',
      'profile.cards': 'Карточки профиля',
      'profile.stats': 'Счётчики профиля',
    },
    cardUses: 'Карточки профиля используют',
    use: {
      'action': 'кнопки действий',
      'link': 'ссылки на холсты и адреса',
      'toggle': 'переключатели и флажки',
      'counter': 'счётчики',
      'note': 'заметки',
      'bind': 'значения от модуля',
      'live:time': 'время и дата',
      'live:timer': 'секундомер',
      'live:countdown': 'обратный отсчёт',
      'live:profile': 'счётчики профиля',
      'anim:appear': 'эффект «появление»',
      'anim:pulse': 'эффект «пульсация»',
      'anim:sway': 'эффект «покачивание»',
      'anim:spin': 'эффект «вращение»',
      'anim:shimmer': 'эффект «перелив»',
      'anim:custom': 'свои анимации',
      'font': 'свои шрифты',
      'image': 'свои картинки',
      'look:image': 'картинка фона',
      'look:motion': 'анимированный фон',
    },
    keyboardHere: 'Клавиатура у модуля · Esc — вернуть',
    sandboxUnsafe: 'Содержимое модуля не показано: песочница не изолирована. Сообщите администратору сервера.',
    enable: 'Включить',
    disable: 'Отключить',
    uninstall: 'Удалить',
    rollback: 'Откатить на {v}',
    restart: 'Перезапустить',
    confirmUninstall: 'Удалить модуль «{name}»? Его объекты сохранятся и будут показаны как недоступные.',
    installed: 'Модуль «{name}» {v} установлен',
    updated: 'Модуль «{name}» обновлён до {v}',
    invalid: 'Модуль не прошёл проверку: {reason}',
    incompatibleApi: 'Модуль требует API {range}, платформа предоставляет {api}',
    oldApi: 'Модуль написан для старой версии платформы (API {range}). Нужна версия модуля для API {api}.',
    device: {
      open: 'Модуль «{name}» хочет открыть файл с вашего компьютера.',
      save: 'Модуль «{name}» хочет сохранить файл на ваш компьютер.',
      read: 'Модуль «{name}» хочет прочитать буфер обмена.',
      write: 'Модуль «{name}» хочет записать в буфер обмена.',
      allow: 'Разрешить',
      denied: 'Пользователь не разрешил',
      tooLarge: 'Файл «{name}» слишком большой',
    },
    isolatedMsg: 'Модуль «{name}» изолирован из-за нарушений: {reason}',
    crashedMsg: 'Модуль «{name}» аварийно завершился и будет перезапущен',
    updateIncompatible:
      'Новая версия модуля «{name}» несовместима с {n} существующими объектами. Откатить обновление? (ОК — откатить, Отмена — оставить новую версию; объекты останутся недоступными)',
    objects: 'Объектов на открытых холстах: {n}',
    bundled: 'Встроенный',
    trustNote: 'Режим разработчика: можно ставить неподписанные модули из файла. Модули из каталога проверены и отмечены «Официальный».',
    grant: 'Разрешить',
    conflict: 'Операция «{op}» заблокирована: модуль сейчас обрабатывает объект',
    ops: { move: 'перемещение', resize: 'изменение размера', rotate: 'поворот', delete: 'удаление', style: 'изменение стиля' },
    permissionsTitle: 'Разрешения модуля',
    permissionsAsk: 'Модуль запрашивает доступ. Отметьте, что разрешить:',
    accessAsk: 'Модуль «{name}» хочет получить доступ к данным:',
    commands: 'Команды',
    revoke: 'Отозвать',
    hint: 'Расширения платформы',
    search: 'Поиск по названию или возможностям',
    nothingFound: 'Ничего не найдено',
    back: 'Все модули',
    open: 'Открыть модуль',
    settingsOf: 'Настройки модуля «{name}»',
    toggleOf: 'Включить модуль «{name}»',
    about: 'О модуле',
    versionLabel: 'Версия',
    apiLabel: 'Версия API',
    publisher: 'Издатель',
    links: 'Ссылки издателя',
    linkKind: { website: 'Сайт', repository: 'Репозиторий', docs: 'Документация', support: 'Поддержка', email: 'Почта', github: 'GitHub', gitlab: 'GitLab', telegram: 'Telegram', vk: 'ВКонтакте', x: 'X', youtube: 'YouTube', discord: 'Discord', other: 'Ссылка' },
    buildDate: 'Дата сборки',
    license: 'Лицензия',
    source: 'Источник',
    idLabel: 'Идентификатор',
    objectsLabel: 'Объектов на открытых холстах',
    features: 'Возможности',
    featObjects: 'Объекты',
    featTools: 'Инструменты',
    featCommands: 'Команды',
    featLinks: 'Типы связей',
    featMcp: 'Инструменты для ИИ',
    status: { experimental: 'Экспериментальный', beta: 'Бета', test: 'Тестовый' },
    statusHint: {
      experimental: 'Эксперимент: может измениться или исчезнуть без предупреждения',
      beta: 'Бета-версия: работает, но ещё дорабатывается',
      test: 'Тестовый модуль: для проверки платформы и API',
    },
    settingsSec: 'Настройки модуля',
    noFeatures: 'Модуль ничего не добавляет на холст',
    access: 'Права доступа',
    accessHint: 'Модуль получает только то, что вы разрешили. Права можно отозвать в любой момент.',
    noPerms: 'Модуль не запрашивает доступ',
    scope: {
      all: 'Все',
      own: 'Свои',
      none: 'Нет',
    },
    permDesc: {
      'canvas.read.all': 'Видеть все объекты и связи открытого холста',
      'canvas.read.own': 'Видеть только свои объекты: своих типов и созданные модулем, пока вы их не изменили',
      'canvas.write.all': 'Создавать объекты и менять любые объекты холста',
      'canvas.write.own': 'Создавать объекты и менять только свои: своих типов и созданные модулем, пока вы их не изменили',
      files: 'Открывать и сохранять файлы',
      clipboard: 'Читать и записывать буфер обмена',
      mcp: 'Вызывать инструменты других модулей — так ИИ-ассистент работает с их объектами',
      feed: 'Показывать свои инструменты в разделе «Инструменты» ленты',
      'canvas.create': 'Создавать новые холсты (например, при переносе из других программ) и открывать их по вашему действию',
      keyboard: 'Получать нажатия клавиш, пока выбран его объект или открыт его вид или окно (кроме Esc и сочетаний с Ctrl/Cmd)',
      fullscreen: 'Разворачивать свой вид или окно на весь экран',
      'pointer-lock': 'Скрывать указатель мыши и получать его движения (игры, 3D); выход — Esc',
      'profile.cards': 'Создавать свои карточки для профиля (без скриптов)',
      'profile.stats': 'Показывать в своих карточках число холстов, объектов, открытий и дней с платформой',
    },
    manage: 'Управление',
    previous: 'Предыдущие версии',
    stopped: 'Модуль не работает',
  },
  diagram: {
    tool: 'Схема (DSkhema)',
    title: 'Схема',
    editTitle: 'Код схемы',
    code: 'Код',
    codeHint: 'Изменить код схемы (двойной клик)',
    preview: 'Предпросмотр',
    templates: 'Шаблоны',
    tplFlow: 'Блок-схема',
    tplSequence: 'Последовательность',
    tplBlank: 'Пустая схема',
    cheatsheet: 'Шпаргалка',
    notation: 'Обозначение',
    meaning: 'Значение',
    apply: 'Готово',
    applyHint: 'Ctrl+Enter',
    cancel: 'Отмена',
    noErrors: 'Ошибок нет',
    fix: 'Исправить',
    fixTo: 'Исправить на «{text}»',
    fixAll: 'Исправить всё',
    errors: 'Ошибок: {n}',
    warnings: 'предупреждений: {n}',
    line: 'Стр. {n}',
    stale: 'Показана последняя версия без ошибок',
    naturalSize: 'Естественный размер',
    explode: 'Разобрать на объекты',
    explodeHint: 'Заменить схему обычными фигурами и соединителями в рамке',
    confirmTemplate: 'Заменить текущий код шаблоном?',
    outdatedVersion: 'Схема старой версии языка. Откройте «Код» и нажмите «Готово».',
    explodeOutdated: 'Сначала обновите схему: откройте «Код» и нажмите «Готово».',
  },
  flow: {
    direction: 'Направление',
    directionHint: 'Куда идёт схема',
    directionNote: 'Меняется заголовок кода схемы; раскладка строится заново.',
    arrange: 'Выстроить',
    arrangeHint: 'Расставить выделенные фигуры и стрелки между ними как схему',
    arrangeNote: 'Фигуры сохраняют размер, первая остаётся на месте; стрелки прокладываются заново. Отмена — Ctrl+Z.',
    down: 'Вниз',
    right: 'Вправо',
    up: 'Вверх',
    left: 'Влево',
    addConnected: 'Добавить связанную фигуру',
    collapse: 'Свернуть ветки',
    expand: 'Развернуть ветки',
  },

  logs: {
    title: 'Журнал диагностики',
    export: 'Экспорт журнала',
    clear: 'Очистить',
    empty: 'Записей нет',
    retention: 'Записи хранятся локально 30 дней и никуда не отправляются.',
    contentWarn: 'Журнал содержит данные объектов из режима подробной отладки. Экспортировать?',
    level: 'Уровень',
    all: 'Все',
    errors: 'Ошибки',
    warnings: 'Предупреждения',
    info: 'Инфо',
    debug: 'Отладка',
    search: 'Поиск по коду и данным',
    today: 'Сегодня',
    yesterday: 'Вчера',
    confirmClear: 'Удалить все записи журнала?',
    refresh: 'Обновить',
    shown: 'Показано {n} из {total}',
  },
  export: {
    title: 'Экспорт',
    scope: 'Что экспортировать',
    selection: 'Выделенные объекты',
    view: 'Видимая область',
    all: 'Весь холст',
    frame: 'Рамка',
    frameHint: 'Рамка вместе с содержимым, обрезанная точно по её краям',
    frames: 'Рамки',
    framePages: 'Каждая рамка — страница',
    scale: 'Масштаб',
    background: 'Фон',
    transparent: 'Прозрачный',
    color: 'Цвет',
    unavailable: 'Недоступные объекты',
    placeholder: 'Заглушка',
    skip: 'Пропустить',
    tooLarge: 'Изображение слишком большое ({w}×{h}). Уменьшите масштаб или область.',
    format: 'Формат',
    go: 'Экспортировать',
    cancel: 'Отмена',
  },
  import: {
    svgEmpty: 'В SVG не нашлось фигур, которые можно перенести',
    svgPartial: 'Добавлено объектов: {n}. Не перенесено элементов: {skipped} (обрезки, маски, фильтры, внешние картинки)',
    svgInvalid: 'Файл {name} — не SVG или повреждён',
    tooNew: 'Архив создан более новой версией платформы ({v}). Обновите страницу или платформу.',
    invalid: 'Архив повреждён или имеет неверный формат: {reason}',
    done: 'Импортировано холстов: {n}',
    missingModules: 'Не установлены модули: {list}. Их объекты сохранены и показаны как недоступные.',
  },
  clipboard: {
    denied: 'Нет доступа к системному буферу обмена — используется внутренний буфер.',
    bigData: 'Вместе с объектами скопируются данные ({size}). Продолжить?',
    copied: 'Скопировано',
    pngFailed: 'Не удалось скопировать изображение',
  },
  error: {
    readOnly: 'Холст открыт только для чтения',
    coordLimit: 'Нельзя разместить объект так далеко: достигнут предел координат ±1 000 000 000',
    undoBlocked: 'Этот шаг нельзя отменить, пока модуль «{module}» недоступен',
    undoIncompatible: 'Этот шаг записан в несовместимом формате модуля «{module}»',
    cycle: 'Связь отклонена: она создаёт цикл зависимостей',
    unknown: 'Ошибка: {msg}',
    webgl: 'WebGL 2 недоступен — используется Canvas 2D',
  },
  common: {
    ok: 'ОК',
    cancel: 'Отмена',
    close: 'Закрыть',
    save: 'Сохранить',
    yes: 'Да',
    no: 'Нет',
    copy: 'Копировать',
    download: 'Скачать',
  },
  rich: {
    toolbar: 'Форматирование текста',
    done: 'Готово',
    doneHint: 'Закончить редактирование (Esc)',
    bold: 'Жирный (Ctrl+B)',
    italic: 'Курсив (Ctrl+I)',
    underline: 'Подчёркнутый (Ctrl+U)',
    strike: 'Зачёркнутый',
    color: 'Цвет текста',
    highlight: 'Маркер',
    noHighlight: 'Без маркера',
    defaultColor: 'Как у объекта',
    font: 'Шрифт фрагмента',
    defaultFont: 'Как у объекта',
    smaller: 'Меньше',
    larger: 'Больше',
    clear: 'Очистить форматирование',
  },
  fonts: {
    inter: 'Inter',
    interHint: 'Основной шрифт: чёткий и нейтральный',
    serif: 'PT Serif',
    serifHint: 'С засечками — для длинных текстов',
    mono: 'JetBrains Mono',
    monoHint: 'Моноширинный — для кода',
    hand: 'Caveat',
    handHint: 'Рукописный — для заметок',
    andika: 'Andika',
    andikaHint: 'Легко читать: разборчивые буквы для начинающих читателей и при дислексии',
    dyslexic: 'OpenDyslexic',
    dyslexicHint: 'Для дислексии: утяжелённый низ букв. Кириллица — шрифтом Andika',
    system: 'Системный',
    systemHint: 'Шрифт операционной системы (в SVG не встраивается)',
  },
  changelog: {
    menu: 'Что нового',
    title: 'Что нового',
    history: 'История изменений',
    gotIt: 'Понятно',
  },
  feedback: {
    menu: 'Сообщить о проблеме',
    title: 'Сообщить о проблеме',
    to: 'Письмо уйдёт на',
    kind: {
      bug: 'Ошибка',
      idea: 'Предложение',
      question: 'Вопрос',
    },
    subject: 'Тема',
    subjectPh: 'Тема обращения',
    placeholder: {
      bug: 'Что случилось и что вы делали перед этим?',
      idea: 'Чего не хватает или что можно сделать лучше?',
      question: 'О чём хотите спросить?',
    },
    attach: 'Приложить технические сведения',
    showInfo: 'Что будет приложено',
    hideInfo: 'Скрыть',
    note: 'Откроется ваша почтовая программа с готовым письмом: вы увидите его целиком и отправите сами. Содержимое холстов не прикладывается.',
    cut: 'Письмо длинное: почтовая программа может обрезать его. Нажмите «Скопировать» и вставьте текст целиком.',
    open: 'Открыть письмо',
    copy: 'Скопировать',
    opened: 'Письмо открыто в почтовой программе',
    copied: 'Скопировано: адрес, тема и текст',
  },
  pwa: {
    install: 'Установить приложение',
    offline: 'Нет сети. Приложение работает, всё сохраняется на этом устройстве',
    offlineBadge: 'без сети',
    offlineHint: 'Каталог модулей и документы откроются, когда сеть вернётся; холсты работают как обычно',
    updateNow: 'Обновить',
  },
  storage: {
    place: {
      title: 'Где хранятся холсты',
      browser: 'В браузере',
      folder: 'В папке',
      change: 'Другая папка…',
      browserHint: 'Холсты этого профиля хранятся в браузере. Место выбрано при создании профиля и не меняется.',
      folderHint: 'Холсты этого профиля — файлы в папке; настройки, журнал и модули — в браузере. Место выбрано при создании профиля и не меняется.',
      copyTitle: 'Скопировать холсты?',
      copyToFolder: 'В браузере {n} холст. Скопировать в папку? Копия в браузере останется.|В браузере {n} холста. Скопировать в папку? Копии в браузере останутся.|В браузере {n} холстов. Скопировать в папку? Копии в браузере останутся.',
      copyToBrowser: 'В папке {n} холст. Скопировать в браузер? Файлы в папке останутся.|В папке {n} холста. Скопировать в браузер? Файлы в папке останутся.|В папке {n} холстов. Скопировать в браузер? Файлы в папке останутся.',
      copyYes: 'Скопировать',
      copyNo: 'Не копировать',
      copying: 'Копирую холсты: {done} из {total}…',
      failed: 'Не получилось открыть папку: {msg}',
    },
    gate: {
      title: 'Холсты хранятся в папке',
      missingTitle: 'Папка с холстами недоступна',
      text: 'После перезапуска браузер просит подтвердить доступ к папке. Нажмите «Разрешить доступ» и согласитесь в окне браузера.',
      missing: 'Папку переименовали, перенесли или удалили. Выберите её на новом месте или смените профиль.',
      error: 'Папку не получилось открыть. Выберите её заново или смените профиль.',
      denied: 'Браузер не дал доступ. Попробуйте ещё раз и выберите «Разрешить».',
      grant: 'Разрешить доступ',
      pick: 'Выбрать папку…',
      browser: 'Работать в браузере',
      note: 'Если папку переименовали или перенесли, выберите её на новом месте: подходит только папка с холстами этого профиля.',
      notThisProfile: 'В этой папке нет холстов этого профиля. Выберите папку, которую профиль использовал.',
    },
    healthFolder: 'Нет доступа к папке «{name}» с холстами: изменения пока только в памяти. Разрешите доступ снова или верните папку на место.',
    healthTitle: 'Данные не сохраняются',
    healthUnavailable: 'Браузер не даёт сохранять данные на этом сайте (возможно, приватное окно или запрещено хранение). Всё, что вы нарисуете, исчезнет при закрытии вкладки. Холсты можно сохранить в файл — «Экспорт».',
    healthQuota: 'Не хватает места в хранилище браузера: последние изменения НЕ сохранены. Освободите место (Настройки → Хранилище) или сделайте экспорт холста, пока вкладка открыта.',
    healthBlocked: 'Не удаётся записать данные: другая вкладка или браузер блокирует базу. Изменения пока только в памяти — сделайте экспорт холста, пока вкладка открыта.',
    healthFailed: 'Ошибка записи на диск: последние изменения могут быть не сохранены. Сделайте экспорт холста, пока вкладка открыта.',
    healthLimited: 'Хранилище браузера ограничено ({quota}) — похоже на приватное окно: данные удалятся при его закрытии. Сохраняйте холсты в файл.',
    exportNow: 'Экспорт холста',
    openStorage: 'Хранилище',
    leaveWarn: 'Есть несохранённые изменения.',
    recovered: 'Сохранение восстановлено',
    attachmentFailed: 'Не удалось сохранить файл: не хватает места в хранилище',
    canvases: 'Холсты',
    attachments: 'Вложения',
    other: 'Прочее',
    otherHint: 'Превью, журнал, модули',
    canvasCount: '{n} холст|{n} холста|{n} холстов',
    fileCount: '{n} файл|{n} файла|{n} файлов',
    browser: 'Всего в браузере (все профили этого устройства): занято {used} из {quota}',
    profileUsage: 'Занято профилем «{name}»',
    largest: 'Самые большие холсты профиля',
    ofFiles: 'файлов',
    backup: 'Резервная копия',
    backupHint: 'Холсты этого профиля хранятся только в этом браузере — экспорт сохраняет все его холсты в файл',
    backupHintFolder: 'Холсты этого профиля — файлы в папке: их можно копировать как есть; экспорт сохраняет все его холсты в один файл',
    unused: 'Неиспользуемые вложения',
    unusedHint: '{n} шт., {size} — картинки, которых больше нет ни на одном холсте этого профиля',
    unusedRemoved: 'Удалено неиспользуемых вложений: {n}',
    remove: 'Удалить',
    logs: 'Журнал',
    logsHint: '{size} — записи этого профиля о работе платформы, без содержимого холстов',
    previews: 'Превью холстов',
    previewsHint: '{size} — превью холстов этого профиля, нарисуются заново при открытии «Моих холстов»',
    clear: 'Очистить',
    clearAll: 'Очистить холсты профиля',
    clearAllHint: 'Удалить все холсты, вложения и превью этого профиля. Его настройки и модули останутся, другие профили не затрагиваются',
    clearAllOk: 'Удалить всё',
    clearAllConfirm: 'Будут удалены все холсты ({n}) вместе с вложениями — восстановить их будет нельзя. Если нужна копия, сначала сделайте экспорт.',
    cleared: 'Хранилище очищено',
  },
  about: {
    tagline: 'Бесконечный холст с модулями. Все данные — в этом браузере',
    version: 'Версия',
    build: 'Сборка',
    buildLocal: 'локальная',
    offline: 'Без сети',
    offlineYes: 'работает (приложение сохранено на устройстве)',
    offlineInstalled: 'работает, установлено как приложение',
    offlineNo: 'нет (откройте приложение по https один раз с сетью)',
    storagePlace: 'Холсты',
    date: 'Дата сборки',
    type: 'Тип сборки',
    type_development: 'Разработка (dev-сервер)',
    type_local: 'Локальная сборка',
    type_preview: 'Предварительная',
    type_beta: 'Бета',
    type_release: 'Релиз',
    commit: 'Коммит',
    renderer: 'Отрисовка',
    api: 'API модулей',
    format: 'Формат данных',
    dskhema: 'Язык схем DSkhema',
    copy: 'Скопировать сведения',
    copyHint: 'Пригодится, если сообщаете о проблеме',
    copied: 'Сведения скопированы',
    site: 'Сайт',
    siteHint: 'Страница о платформе',
    siteOpen: 'Открыть',
  },
  boolean: {
    title: 'Объединение',
    hint: 'Сложение, вычитание, пересечение фигур',
    skipped: 'Участвуют {n} из {total}',
    union: 'Сложение',
    unionHint: 'Слить фигуры в одну',
    unionKey: 'Ctrl+Alt+U',
    subtract: 'Вычитание',
    subtractHint: 'Вычесть верхние фигуры из нижней',
    subtractKey: 'Ctrl+Alt+S',
    intersect: 'Пересечение',
    intersectHint: 'Оставить только общую часть',
    intersectKey: 'Ctrl+Alt+I',
    exclude: 'Исключение',
    excludeHint: 'Убрать общую часть, оставить остальное',
    excludeKey: 'Ctrl+Alt+E',
    divide: 'Разделение',
    divideHint: 'Разрезать на отдельные части по всем границам',
    note: 'Результат — контур с видом нижней фигуры; одно действие отмены. Кривые превращаются в многоугольники.',
    empty: 'Фигуры не пересекаются — результат пустой',
    failed: 'Не удалось объединить эти фигуры',
  },
  palette: {
    bookmark: 'Закладка: {name}',
    title: 'Палитра команд',
    placeholder: 'Команда или текст на холсте…',
    empty: 'Ничего не найдено',
    group: {
      recent: 'Недавние',
      edit: 'Правка',
      tools: 'Инструменты',
      view: 'Вид',
      canvas: 'Холст',
      modules: 'Модули',
      objects: 'На холсте',
    },
    copyStyle: 'Копировать стиль',
    pasteStyle: 'Вставить стиль',
    styleCopied: 'Стиль скопирован — Ctrl+Alt+V, чтобы вставить',
    brush: 'Кисть стиля',
    brushTitle: 'Кисть стиля: щёлкните объект, чтобы перенести на него этот стиль',
    brushHint: 'Щёлкните объект, чтобы применить стиль',
    defaultStyle: 'Стиль по умолчанию',
    defaultStyleHint: 'Новые объекты этого типа будут выглядеть так же',
    resetDefaultStyle: 'Обычный стиль для новых',
    keepRatio: 'Сохранять пропорции',
    freeRatio: 'Не сохранять пропорции',
    showMinimap: 'Показать мини-карту',
    hideMinimap: 'Скрыть мини-карту',
    showTree: 'Показать дерево объектов',
    hideTree: 'Скрыть дерево объектов',
    guidesOn: 'Включить направляющие',
    guidesOff: 'Выключить направляющие',
    darkTheme: 'Тёмная тема',
    lightTheme: 'Светлая тема',
    template: 'Шаблон: {name}',
    panel: 'Панель: {name}',
  },
  bookmarks: {
    title: 'Закладки',
    add: 'Сохранить текущий вид',
    defaultName: 'Вид {n}',
    empty: 'Закладок пока нет: сохраните место и масштаб, чтобы возвращаться к ним одним щелчком.',
    hint: 'Закладки хранятся вместе с холстом. На закладку можно сослаться с объекта.',
    go: 'Перейти',
    rename: 'Переименовать',
    update: 'Запомнить текущий вид',
    up: 'Выше',
    tooMany: 'Не больше {n} закладок на холсте',
  },
  links: {
    title: 'Ссылка',
    add: 'Добавить ссылку',
    edit: 'Изменить ссылку',
    follow: 'Перейти по ссылке',
    remove: 'Убрать',
    pick: 'Выбрать объект на холсте',
    pickHint: 'Щёлкните объект, на который будет вести ссылка',
    set: 'Ссылка сохранена',
    object: 'объект',
    missing: 'не найдено',
    noBookmarks: 'На этом холсте нет закладок — сохраните вид в меню закладок (кнопка у масштаба).',
    noCanvases: 'Других холстов пока нет.',
    badUrl: 'Нужен адрес http(s) или e-mail',
    brokenBookmark: 'Закладки, на которую ведёт ссылка, больше нет',
    brokenObject: 'Объекта, на который ведёт ссылка, больше нет',
    brokenCanvas: 'Холста, на который ведёт ссылка, больше нет',
    kind: { bookmark: 'Закладка', object: 'Объект', canvas: 'Холст', url: 'Адрес' },
  },
  components: {
    make: 'Создать компонент',
    namePrompt: 'Название компонента',
    defaultName: 'Компонент {n}',
    insert: 'Вставить экземпляр',
    insertNamed: 'Компонент: {name}',
    goMaster: 'Перейти к образцу',
    reset: 'Сбросить изменения экземпляра',
    detach: 'Отсоединить от компонента',
    master: 'Образец компонента',
    instance: 'Экземпляр компонента',
  },
  notes: {
    title: 'Заметки',
    open: 'Комментарии',
    reactions: 'Реакции',
    empty: 'Комментариев пока нет',
    placeholder: 'Комментарий… (Ctrl+Enter)',
    add: 'Добавить',
    done: 'Готово',
  },
  legal: {
    title: 'Прежде чем начать',
    text: 'Пожалуйста, прочитайте политику конфиденциальности и правила использования. Нажимая «Принимаю», вы соглашаетесь с ними.',
    updatedTitle: 'Документы обновились',
    updatedText: 'Мы изменили политику конфиденциальности или правила использования. Пожалуйста, прочитайте новую редакцию.',
    note: 'Ваши холсты остаются в этом браузере — на сервер они не отправляются.',
    accept: 'Принимаю',
    docs: 'Документы',
    docsHint: 'Политика конфиденциальности и правила использования',
  },
  notice: {
    more: 'Подробнее',
    close: 'Закрыть',
  },
  catalog: {
    tab: 'Каталог',
    installedTab: 'Установленные',
    fromFile: 'Установить из файла',
    devLink: 'Свой неподписанный модуль? Включите режим разработчика.',
    official: 'Официальный',
    install: 'Установить',
    update: 'Обновить',
    updateTo: 'Обновить до {v}',
    installed: 'Установлен',
    loading: 'Загружаю каталог…',
    offline: 'Каталог сейчас недоступен. Установленные модули работают как обычно.',
    stale: 'Сервер каталога не отвечает — показан последний сохранённый список.',
    empty: 'В каталоге пока нет модулей.',
    installTitle: 'Установка модуля',
    asks: 'Модуль просит доступ:',
    replaces: 'Сейчас установлена версия {v} — она будет заменена, данные сохранятся.',
    needsDev: 'Этот файл не подписан каталогом. Неподписанные модули ставятся только в режиме разработчика.',
    trustNote: 'Модули из каталога проверены и подписаны. Файл модуля, скачанный с витрины, тоже можно установить.',
    err: {
      offline: 'Не удалось связаться с каталогом. Проверьте интернет и попробуйте ещё раз.',
      'not-found': 'Такого модуля или версии в каталоге нет.',
      damaged: 'Файл модуля повреждён или изменён. Установка отменена.',
      untrusted: 'Модуль подписан ключом, которому эта версия приложения не доверяет. Установка отменена.',
      revoked: 'Подпись этого модуля отозвана. Установка отменена.',
      mismatch: 'Файл модуля не совпадает со своей подписью. Установка отменена.',
    },
  },
};
